module.exports = ".report-details .modal-dialog {\n  width: 500px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/report-details-modal/report-details-modal.component.scss
// module id = ./src/app/shared/components/report-details-modal/report-details-modal.component.scss
// module chunks = main